/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

import createPersistedState from "vuex-persistedstate";

// 共通系
import auth from "./auth/moduleAuth";
import notification from "./notification/moduleNotification";
import session from "./modules/session";
import account from "./modules/account";
import constantResource from "./modules/moduleConstantResource";

// 法人系
import mapSetting from "./enterprise/map/setting/moduleEnterpriseMapSetting";
import liveMap from "./enterprise/live-map/moduleLiveMap";
import enterpriseUser from "./enterprise/user/moduleUser";
import enterpriseUserList from "./enterprise/user-list/moduleUserList";
import enterpriseUserView from "./enterprise/user-view/moduleUserView";
import enterpriseUserAdd from "./enterprise/user-add/moduleUserAdd";
import enterpriseUserEdit from "./enterprise/user-edit/moduleUserEdit";
import enterpriseLicenseEdit from "./enterprise/license-edit/moduleLicenseEdit";
import enterpriseLicenseAdd from "./enterprise/license-add/moduleLicenseAdd";
import enterpriseVessel from "./enterprise/vessel/moduleEnterpriseVessel";
import enterpriseVesselList from "./enterprise/vessel-list/moduleEnterpriseVesselList";
import enterpriseVesselView from "./enterprise/vessel-view/moduleEnterpriseVesselView";
import enterpriseVesselEdit from "./enterprise/vessel-edit/moduleEnterpriseVesselEdit";
import enterpriseCameraList from "./enterprise/camera-list/moduleCameraList";
import enterpriseMapVessel from "./enterprise/map/vessel/moduleEnterpriseMapVessel";
import enterpriseMapVesselSelected from "./enterprise/map/vessel_selected/moduleEnterpriseMapVesselSelected";
import enterpriseMapVesselTarget from "./enterprise/map/vessel_target/moduleEnterpriseMapVesselTarget";
import enterpriseMapVesselSearch from "./enterprise/map/vessel_search/moduleEnterpriseMapVesselSearch";
import enterprisePlotEdit from "./enterprise/plot/edit/modulePlotEdit";
import enterprisePlot from "./enterprise/plot/modulePlot";
import enterprisePlotTarget from "./enterprise/plot/plot_target/moduleMapPlotTarget";
import enterprisePlotList from "./enterprise/plot/list/modulePlotList";
import enterpriseMapSetting from "./enterprise/map/setting/moduleEnterpriseMapSetting";
import enterpriseVoyageHistory from "./enterprise/voyage-history/moduleVoyageHistory";
import enterpriseVesselVoyageHistory from "./enterprise/vessel-voyage-history/moduleVoyageHistory";
import forecastWindy from "./enterprise/live-map/forecast-windy/moduleForecastWindy";
import gridMap from "./enterprise/grid-map/moduleGridMap";
import radarGridPlayback from "./addon/gkmg/radar-grid/playback/moduleRGPlayback";

// 機能拡張系
import portMasterDestinationWork from "./addon/port-master/destination-work/moduleDestinationWork";
import portMasterDestinationWorkEdit from "./addon/port-master/destination-work-edit/moduleDestinationWorkEdit";
import portMaster from "./addon/port-master/modulePortMaster";
// GKMG用port-master
import gkmgPortMasterDestinationWork from "./addon/gkmg-port-master/destination-work/moduleDestinationWork";
import gkmgPortMaster from "./addon/gkmg-port-master/modulePortMaster";

import gkmgPrivatePlot from "./addon/gkmg/private-plot/modulePrivatePlot";
import gkmgAnchor from "./addon/gkmg/anchor/moduleAnchor";
import gkmgVesselEquipmentBaseStation from "./addon/gkmg/base-station/moduleVesselEquipmentBaseStation";

Vue.use(Vuex);

const store = new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({
      paths: [
        "portMaster.selectedPort",
        "portMasterDestinationWorkEdit.destinationWorkImportedTasksMap",
        "enterpriseVesselView.kindOriginVersionMap",
        "portMaster.storedMasterSearchCondition",
        "portMasterDestinationWorkEdit.selectedDateDisplay1",

        "gkmgPortMaster.storedMasterSearchCondition",
        "gkmgPortMasterDestinationWork.selectedDate",
      ],
    }),
  ],
  modules: {
    auth: auth,
    mapSetting: mapSetting,
    liveMap: liveMap,
    notification: notification,
    enterpriseUserList: enterpriseUserList,
    enterpriseUserView: enterpriseUserView,
    enterpriseUserAdd: enterpriseUserAdd,
    enterpriseUserEdit: enterpriseUserEdit,
    enterpriseLicenseEdit: enterpriseLicenseEdit,
    enterpriseLicenseAdd: enterpriseLicenseAdd,
    enterpriseVesselList: enterpriseVesselList,
    enterpriseVesselView: enterpriseVesselView,
    enterpriseVesselEdit: enterpriseVesselEdit,
    enterpriseCameraList: enterpriseCameraList,
    session: session,
    account: account,
    enterpriseUser,
    enterpriseVessel,
    enterpriseMapVessel,
    enterpriseMapVesselSelected,
    enterpriseMapVesselTarget,
    enterpriseMapVesselSearch,
    enterprisePlot,
    enterprisePlotList,
    enterprisePlotEdit,
    enterprisePlotTarget,
    enterpriseMapSetting,
    constantResource,
    enterpriseVoyageHistory,
    enterpriseVesselVoyageHistory,
    forecastWindy: forecastWindy,
    gridMap: gridMap,
    radarGridPlayback: radarGridPlayback,

    portMaster,
    portMasterDestinationWork,
    portMasterDestinationWorkEdit,

    gkmgPortMasterDestinationWork,
    gkmgPortMaster,

    gkmgPrivatePlot,
    gkmgAnchor,
    gkmgVesselEquipmentBaseStation,
  },
});

export default store;
